import React, { useEffect, useState } from "react";
import { getMyAdminProfile } from "../../api/admin";
import { person } from "../../assets/img";

const AdminHeader = () => {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    getMyAdminProfile()
      .then((res) => {
         console.log("ADMIN DATA:", res.data.admin); // ✅ check full data
        setAdmin(res.data.admin);
      })
      .catch((err) => {
        console.error("Failed to fetch admin profile:", err);
      });
  }, []);

  if (!admin) return null;

  console.log("PROFILE IMAGE URL:", admin.profileImage);

  return (
    <div className="employee-header">
      <div className="employee-info">
        <h1>
          Employee ID : <span>{admin.employeeId}</span>
        </h1>
        <h3>
          Name : <span>{admin.username}</span>
        </h3>
      </div>

      <div className="employee-avatar">
         <img
  src={admin.profileImage || person}
  alt="Admin"

  onLoad={() => {
    console.log("✅ IMAGE LOADED SUCCESSFULLY");
  }}

  onError={(e) => {
    console.log("❌ IMAGE FAILED TO LOAD");
    console.log("BROKEN URL:", admin.profileImage);

    e.target.src = person;
  }}
/>
      </div>
    </div>
  );
};

export default AdminHeader;